import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// constants
import { RentalsActionTypes } from "./constants";
import { RentalsApiResponseSuccess, RentalsApiResponseError } from "./actions";
import { getAllRentals } from "../../helpers/api/rentals";

// Fetch rentals saga
function* getRentalsSaga({ payload: { start_date, user, status } }: any): SagaIterator {
  try {
    const response = yield call(getAllRentals, start_date, user, status);
    const rentals = response?.data?.data?.rentals_history;

    yield put(RentalsApiResponseSuccess(RentalsActionTypes.GET_RENTALS, rentals));
  } catch (error: any) {
    yield put(RentalsApiResponseError(RentalsActionTypes.GET_RENTALS, error));
  }
}

// Watchers
export function* watchGetRentals() {
  yield takeEvery(RentalsActionTypes.GET_RENTALS, getRentalsSaga);
}

// Root saga
function* RentalsSaga() {
  yield all([fork(watchGetRentals)]);
}

export default RentalsSaga;
